// extracted by mini-css-extract-plugin
export default {"dark":"styles_dark__-Vl1A","container":"styles_container__1bsuS","appPlay":"styles_appPlay__Bw8UG"};